import Icon from '@/components/Icon'
import Vue from 'vue'

const CouriersListExtras = () => import(/* webpackChunkName: "companies" */ '@/components/Couriers/ListExtras')
const UsersListItemId = () => import(/* webpackChunkName: "companies" */ '@/components/Users/ListItemId')
const UsersListItemProfilePicture = () => import(/* webpackChunkName: "companies" */ '@/components/Users/ListItemProfilePicture')
const CouriersListItemName = () => import(/* webpackChunkName: "companies" */ '@/components/Couriers/ListItemName')
const UsersListItemEmail = () => import(/* webpackChunkName: "companies" */ '@/components/Users/ListItemEmail')
const UsersListItemPhone = () => import(/* webpackChunkName: "companies" */ '@/components/Users/ListItemPhone')
const UsersListItemCompany = () => import(/* webpackChunkName: "companies" */ '@/components/Users/ListItemCompany')
const CouriersListItemActive = () => import(/* webpackChunkName: "companies" */ '@/components/Couriers/ListItemActive')
const CouriersListItemFree = () => import(/* webpackChunkName: "companies" */ '@/components/Couriers/ListItemFree')
const CouriersListActions = () => import(/* webpackChunkName: "companies" */ '@/components/Couriers/ListActions')

const couriersModel = vm => ({
  title: vm.isMoova ? vm.$gettext('Moovers') : vm.$gettext('Couriers'),
  endpoint: 'users',
  allowNew: true,
  countrize: 'country_iso_code',
  listExtrasComponent: CouriersListExtras,
  fields: [
    {
      key: 'id',
      sortable: true,
      component: (value, key, item) => ({
        is: UsersListItemId,
        props: { value, item }
      })
    },
    {
      key: 'profile_picture',
      sortable: false,
      label: vm.$gettext('Picture'),
      component: (value, key, item) => ({
        is: UsersListItemProfilePicture,
        props: { item }
      })
    },
    {
      key: 'name',
      label: vm.$gettext('Name'),
      sortable: true,
      editable: true,
      component: (value, key, item) => ({
        is: CouriersListItemName,
        props: { item }
      })
    },
    {
      key: 'email',
      label: vm.$gettext('Email'),
      sortable: true,
      editable: true,
      component: (value, key, item) => ({
        is: UsersListItemEmail,
        props: { item }
      })
    },
    {
      key: 'phone',
      label: vm.$gettext('Phone'),
      component: (value, key, item) => ({
        is: UsersListItemPhone,
        props: { item }
      })
    },
    {
      key: 'company_id',
      sortable: true,
      label: vm.$gettext('Company'),
      formatter: (value, key, item) => {
        return item.company ? item.company.name : ''
      },
      component: (value, key, item) => ({
        is: UsersListItemCompany,
        props: { item }
      })
    },
    {
      key: 'cod',
      label: vm.$gettext('COD'),
      formatter: (value, key, item) => {
        let html = ''
        if (item.courier_available && item.courier_available.carrying_cash_amount) {
          if (item.courier_available.skips_cash_control) {
            html += new Vue({
              ...Icon,
              parent: this,
              propsData: {
                icon: 'exclamation-triangle',
                className: 'text-warning',
                title: vm.$gettext('Skips Cash Control')
              }
            }).$mount().$el.outerHTML
          }
          html +=
            ' ' +
            Vue.options.filters.currency(item.courier_available.carrying_cash_amount, item.country_iso_code)
        }
        return html
      }
    },
    {
      key: 'active',
      label: vm.$gettext('Active'),
      editable: false,
      component: (value, key, item) => ({
        is: CouriersListItemActive,
        props: { item }
      })
    },
    {
      key: 'free',
      label: vm.$gettext('Free'),
      editable: false,
      component: (value, key, item) => ({
        is: CouriersListItemFree,
        props: { item }
      })
    },
    {
      key: 'actions',
      label: vm.$gettext('Actions'),
      hidden: true,
      component: (value, key, item, row) => ({
        is: CouriersListActions,
        props: { row }
      })
    }
  ],
  filters: ['id', 'name', 'email', 'phone', 'company_id', 'tags.name'],
  includes: ['courier_available.tracking', 'fixed_amounts.fixed_tour', 'tags', 'company.tags']
})

export default couriersModel
